import React, { useState, useEffect, useRef } from "react";
import { data, useNavigate } from "react-router-dom";
import Navbarmanager, { loadNav, infoUtente } from "./Navbar";
import Table from "../../components/Table";
import PopUp from "../../components/PopUp";
import Combobox from "../../components/Combobox";
import Input from "../../components/Input";
import Toggle from "../../components/Toggle";
import Checkbox from "../../components/Checkbox";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import { Trash2, SquarePen, Factory, X, KeyRound, MonitorSmartphone, History } from "lucide-react";

const RowPC = ({ data }) => {
    return (
        <>
            <div className="grid grid-cols-5 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.Nome}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Cognome}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Email}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Stato}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.CodiceDispositivo}
                </div>
            </div>
        </>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && header.key !== '' && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm">
                                {data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
}

const Utenti = () => {
    const headers = [
        { label: 'Nome', key: 'Nome' },
        { label: 'Cognome', key: 'Cognome' },
        { label: 'Email', key: 'Email' },
        { label: 'Stato', key: 'Stato' },
        { label: 'Dispositivo', key: 'CodiceDispositivo' }
    ];
    const [dataTable, setDataTable] = useState([]);
    const [dataAdd, setDataAdd] = useState({
        "Nome": null,
        "Cognome": null,
        "Email": null,
        "Password": null,
        "ConfermaPassword": null
    });
    const [dataRow, setDataRow] = useState(null);
    const [dataPassword, setDataPassword] = useState({});
    const [isAddVisible, setIsAddVisible] = useState(false);
    const [isRowInfoVisible, setIsRowInfoVisible] = useState(false);
    const [needConfirmRow, setNeedConfirmRow] = useState(false);
    const [isGestioneVisible, setIsGestioneVisible] = useState(false);
    const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [utentiDisponibili, setUtentiDisponibili] = useState(0);
    const [eliminazioniRimaste, setEliminazioniRimaste] = useState(0);
    const [optionsAziende, setOptionsAziende] = useState([]);
    const [isShowingArchived, setIsShowingArchived] = useState(false);
    const toggleRef1 = useRef(null);
    const [statusToggle1, setStatusToggle1] = useState(false);
    const toggleRef2 = useRef(null);
    const [useDataAdd, setUseDataAdd] = useState(null);
    const [selectedAziende, setSelectedAziende] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        if (isGestioneVisible && useDataAdd !== null && useDataAdd === false) {
            const loadAziende = async () => {
                setIsLoading(true);
                try {
                    const r = await fetch('/getGestioneUtente', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            IDUtente: dataRow.value["ID"],
                            CodiceDominio: infoUtente["CodiceDominio"]
                        })
                    });
                    const rd = await r.json();

                    if (r.status === 500) {
                        console.error(rd.error);
                        setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); setIsGestioneVisible(false) }, needConfirm: false });
                        setShowAlert(true);
                    } else {
                        setIsLoading(false);
                        if (rd[0]["IDAzienda"] === null) {
                            setSelectedAziende([]);
                            if (toggleRef1.current) {
                                toggleRef1.current.setValue(true);
                                setStatusToggle1(true);
                            }
                            if (toggleRef2.current) {
                                toggleRef2.current.setValue(rd[0]["InvioEmail"]);
                            }
                        }
                        else {
                            if (toggleRef1.current) {
                                toggleRef1.current.setValue(false);
                                setStatusToggle1(false);
                            }
                            setSelectedAziende(rd.map((a) => ({ ID: a["IDAzienda"], InvioEmail: a["InvioEmail"], Nome: optionsAziende.find((s) => s["ID"] === a["IDAzienda"])["Nome"] })));
                        }
                    }
                } catch (error) {
                    console.error(error);
                    setAlertInfo({ type: "error", text: "Errore nel caricamento delle aziende, riprova più tardi.", onClose: () => { setShowAlert(false); setIsGestioneVisible(false) }, needConfirm: false });
                    setShowAlert(true);
                }
                setIsLoading(false);
            };
            loadAziende();
        }
    }, [isGestioneVisible])

    const onload = async () => {
        let dataCopy = [];

        setIsLoading(true);

        try {

            await loadNav();

            //loadDati
            const r2 = await fetch('/getUtenti', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"]
                })
            });
            const rd2 = await r2.json();
            if (r2.status === 500) {
                console.error(rd2.error);
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); navigate("/manager/dash") }, needConfirm: false });
                setShowAlert(true);
            } else {
                setDataTable(rd2.map(item => ({ value: item })));
                dataCopy = rd2.map(item => ({ value: item }));

                //loadSelectAziende
                const r3 = await fetch('/getAziende', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"]
                    })
                });
                const rd3 = await r3.json();
                if (r3.status === 500) {
                    console.error(rd3.error);
                    setAlertInfo({ type: "error", text: rd3.error, onClose: () => { setShowAlert(false); navigate("/manager/dash") }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setOptionsAziende(rd3.filter((d) => d["Obsoleta"] === false));

                    //calcolo utenti disponibili e eliminazioni rimaste
                    const r4 = await fetch('/getInfoPiano', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente["CodiceDominio"]
                        })
                    });
                    const rd4 = await r4.json();
                    if (r4.status === 500) {
                        console.error(rd4.error);
                        setAlertInfo({ type: "error", text: rd4.error, onClose: () => { setShowAlert(false); navigate("/manager/dash") }, needConfirm: false });
                        setShowAlert(true);
                    } else {
                        setUtentiDisponibili(rd4[0]["NumeroUtenti"] === 99 ? 99 : rd4[0]["NumeroUtenti"] - dataCopy.filter((d) => d.value["DataEliminazione"] === null).length);

                        const r5 = await fetch('/getDominio', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente["CodiceDominio"]
                            })
                        });
                        const rd5 = await r5.json();
                        if (r5.status === 500) {
                            console.error(rd5.error);
                            setAlertInfo({ type: "error", text: rd5.error, onClose: () => { setShowAlert(false); navigate("/manager/dash") }, needConfirm: false });
                            setShowAlert(true);
                        } else {
                            setEliminazioniRimaste(rd5[0]["EliminazioniUtentiRimaste"]);
                        }
                    }
                }

            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprova più tardi.", onClose: () => { setShowAlert(false); navigate("/manager/dash") }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleElimina = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const response = await fetch('/eliminaUser', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ID: dataRow.value["ID"],
                        CodiceDominio: infoUtente["CodiceDominio"],
                        EliminazioniRimaste: eliminazioniRimaste - 1
                    })
                });
                if (response.status === 500) {
                    const responseData = await response.json();
                    console.error(responseData.error);
                    setAlertInfo({ type: "error", text: responseData.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    window.location.reload();
                }
            } catch (error) {
                console.error(error);
                setAlertInfo({ type: "error", text: "Errore nell'eliminazione dell'utente, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare l'utente?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const handleRecupera = async () => {
        if (utentiDisponibili === 0) {
            setAlertInfo({ type: "info", text: "Per recuperare l'utente è necessario avere almeno un utente disponibile", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        const pass = async () => {
            setIsLoading(true);
            try {
                const response = await fetch('/recuperaUser', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ID: dataRow.value["ID"]
                    })
                });
                if (response.status === 500) {
                    const responseData = await response.json();
                    console.error(responseData.error);
                    setAlertInfo({ type: "error", text: responseData.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    window.location.reload();
                }

            } catch (error) {
                console.error(error);
                setAlertInfo({ type: "error", text: "Errore nel recupero dell'utente, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler recuperare l'utente?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const handleChangeDispositivo = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const response = await fetch('/deassociaDispositivo', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ID: dataRow.value["ID"]
                    })
                });
                if (response.status === 500) {
                    const responseData = await response.json();
                    console.error(responseData.error);
                    setAlertInfo({ type: "error", text: responseData.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    window.location.reload();
                }
            } catch (error) {
                console.error(error);
                setAlertInfo({ type: "error", text: "Errore nel cambio del dispositivo, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler cambiare il dispositivo? L'azione è irreversibile.", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const confirmPopUpModifica = async () => {
        if (!dataRow.value["Nome"] || !dataRow.value["Cognome"] || !dataRow.value["Email"]) {
            setAlertInfo({ type: "warning", text: "Compila tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const r1 = await fetch('/aggiornaUtente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ID: dataRow.value["ID"],
                    Nome: dataRow.value["Nome"],
                    Cognome: dataRow.value["Cognome"],
                    Email: dataRow.value["Email"],
                })
            });
            if (r1.status === 500) {
                const rd1 = await r1.json();
                console.error(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore nella modifica dell'utente, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const confirmPopUpAdd = async () => {
        if (!checkPassword(dataAdd["Password"])) {
            setAlertInfo({ type: "warning", text: "La password non rispetta i requisiti", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            setDataAdd(prev => ({ ...prev, Password: '', ConfermaPassword: '' }));
            return;
        }

        //Controllo che la nuova password e la conferma password siano uguali
        if (dataAdd["Password"] !== dataAdd["ConfermaPassword"]) {
            setAlertInfo({ type: "warning", text: "Le password non coincidono", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            setDataAdd(prev => ({ ...prev, Password: '', ConfermaPassword: '' }));
            return;
        }

        if (!dataAdd["Nome"] || !dataAdd["Cognome"] || !dataAdd["Email"] || !dataAdd["Password"] || !dataAdd["ConfermaPassword"]) {
            setAlertInfo({ type: "warning", text: "Compila tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);
        try {
            const response1 = await fetch('/addUser', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Nome: dataAdd["Nome"],
                    Cognome: dataAdd["Cognome"],
                    Email: dataAdd["Email"],
                    Password: dataAdd["Password"],
                    CodiceDominio: infoUtente["CodiceDominio"],
                    Livello: "Utente",
                    Stato: "In attesa di conferma"
                })
            });

            if (response1.status === 500) {
                const responseData = await response1.json();
                console.error(responseData.error);
                setAlertInfo({ type: "error", text: responseData.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }

            const r2 = await fetch('/addGestioneTotale', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    EmailUtente: dataAdd["Email"],
                    InvioMail: false
                })
            });

            if (r2.status === 500) {
                const rd2 = await r2.json();
                console.error(rd2.error);
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }
        } catch (error) {
            setAlertInfo({ type: "error", text: "Errore nell'aggiunta dell'utente, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            console.error(error);
        }
        setIsLoading(false);
    };

    const confirmPopUpPassword = async () => {
        if (!checkPassword(dataPassword["Password"])) {
            setAlertInfo({ type: "warning", text: "La nuova password non rispetta i requisiti", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            setDataPassword({ Password: '', ConfermaPassword: '' });
            return;
        }

        if (dataPassword["Password"] !== dataPassword["ConfermaPassword"]) {
            setAlertInfo({ type: "warning", text: "Le password non coincidono", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            setDataPassword({ Password: '', ConfermaPassword: '' });
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch('/aggiornaPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ID: data["ID"],
                    Password: dataPassword["Password"]
                })
            });
            if (response.status === 500) {
                const responseData = await response.json();
                console.error(responseData.error);
                setAlertInfo({ type: "error", text: responseData.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore nel cambio password, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const checkPassword = (password) => {
        if (password === null || password.trim() === "") return false;
        let check = true;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const numberPattern = /[0-9]/;

        if (!uppercasePattern.test(password)) {
            check = false;
        }
        if (!lowercasePattern.test(password)) {
            check = false;
        }
        if (!specialCharPattern.test(password)) {
            check = false;
        }
        if (!numberPattern.test(password)) {
            check = false;
        }
        if (password.length < 8) {
            check = false;
        }

        return check;
    };

    const checkEmail = async (isAdd) => {
        let email = isAdd ? dataAdd["Email"] : dataRow.value["Email"];
        if (email.trim() === "" || email === null) return;

        try {
            const response = await fetch('/checkEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: email }),
            });
            if (response.status === 401) {
                const data = await response.json();
                setAlertInfo({ type: "error", text: data['error'], onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
                if (isAdd) {
                    setDataAdd(prev => ({ ...prev, Email: '' }));
                } else {
                    setDataRow(prev => ({ ...prev, value: { ...prev.value, Email: '' } }));
                }
            }
            else if (response.status !== 200) {
                const data = await response.json();
                console.error(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            setAlertInfo({ type: "error", text: "Errore nel controllo della mail, riprovare più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            console.log(error);
        }

    };

    const handleToggleChange1 = (value) => {
        setStatusToggle1(value);
    };

    const confirmPopUpClienti = async () => {
        if (useDataAdd === null) return;
        setIsLoading(true);
        if (toggleRef1.current) {
            let status = toggleRef1.current.getValue();
            try {
                if (status) {
                    let toggleStatus = false;
                    if (toggleRef2.current) {
                        toggleStatus = toggleRef2.current.getValue();
                    }
                    const r2 = await fetch('/aggiornaGestioneTotale', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente["CodiceDominio"],
                            IDUtente: useDataAdd ? dataAdd["ID"] : dataRow.value["ID"],
                            EmailUtente: useDataAdd ? dataAdd["Email"] : dataRow.value["Email"],
                            InvioMail: toggleStatus
                        })
                    });
                    if (r2.status === 500) {
                        const rd2 = await r2.json();
                        console.error(rd2.error);
                        setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                        setShowAlert(true);
                    } else {
                        window.location.reload();
                    }
                } else {
                    const r2 = await fetch('/aggiornaGestione', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente["CodiceDominio"],
                            IDUtente: useDataAdd ? dataAdd["ID"] : dataRow.value["ID"],
                            EmailUtente: useDataAdd ? dataAdd["Email"] : dataRow.value["Email"],
                            Aziende: selectedAziende
                        })
                    });
                    if (r2.status === 500) {
                        const rd2 = await r2.json();
                        console.error(rd2.error);
                        setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                        setShowAlert(true);
                    } else {
                        window.location.reload();
                    }
                }
            } catch (error) {
                console.error(error);
                setAlertInfo({ type: "error", text: "Errore nell'aggiornamento delle aziende, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
        }
        setIsLoading(false);
    };

    const addAzienda = (IDAzienda) => {
        let azienda = optionsAziende.find(item => item.ID === IDAzienda);
        if (azienda) {
            setSelectedAziende(prev => [...prev, { ID: azienda.ID, InvioEmail: false, Nome: azienda.Nome }]);
        }
    };

    return (
        <div className="h-[100svh]">
            <Navbarmanager page={"UTENTI"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <div className="w-[80%] md:w-[30%] mx-auto mt-3">
                    <p className="flex justify-between">
                        Utenti rimasti :
                        <span className="font-semibold">{utentiDisponibili === 99 ? "∞" : utentiDisponibili}</span>
                    </p>
                    <p className="flex justify-between mt-1">
                        Eliminazioni di utenti rimaste :
                        <span className="font-semibold">{eliminazioniRimaste}</span>
                    </p>
                </div>
                <Table
                    headers={headers}
                    keyForPreview={["Nome", "Email", "Stato"]}
                    data={dataTable}
                    setData={setDataTable}
                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} />}
                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                    itemsPC={9}
                    itemsMobile={7}
                    needResearch={true}
                    clickableRow={true}
                    archiveClickable={true}
                    actionRow={(row, rowIndex, showArchived) => { setDataRow(row); setIsShowingArchived(showArchived); setIsRowInfoVisible(true) }}
                    classes="mt-2"
                    needAdd={utentiDisponibili > 0}
                    addAction={() => setIsAddVisible(true)}
                    needArchive={true}
                    archiveKey="DataEliminazione"
                    archiveDisequal={true}
                    archiveValue={null}
                />
                <PopUp title={needConfirmRow ? "Modifica Informazioni Utente" : ""}
                    isVisible={isRowInfoVisible}
                    setIsVisible={setIsRowInfoVisible}
                    needConfirm={needConfirmRow}
                    confirmAction={confirmPopUpModifica}
                    cancelAction={() => { setDataRow(null); setNeedConfirmRow(false); }}
                >
                    {needConfirmRow && (
                        <div className="flex flex-col items-center">
                            <Input
                                label="Nome *"
                                value={dataRow.value["Nome"]}
                                setValue={(value) => setDataRow(prev => ({ ...prev, value: { ...prev.value, Nome: value } }))}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                            <Input
                                label="Cognome *"
                                value={dataRow.value["Cognome"]}
                                setValue={(value) => setDataRow(prev => ({ ...prev, value: { ...prev.value, Cognome: value } }))}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                            />
                            <Input
                                label="Email *"
                                value={dataRow.value["Email"]}
                                setValue={(value) => setDataRow(prev => ({ ...prev, value: { ...prev.value, Email: value } }))}
                                type="text"
                                classes="w-[80%] md:w-[70%] mt-2"
                                disabled={false}
                                error={false}
                                blurAction={() => checkEmail(false)}
                            />
                        </div>
                    )}
                    {!needConfirmRow && (
                        <>
                            {
                                isShowingArchived ? (
                                    <>
                                        <div className="flex items-center justify-center mt-2">
                                            <Button type="hollow" classes="w-full" onClick={handleRecupera}>
                                                RIPRISTINA UTENTE <History size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="grid grid-cols-2 mt-2 gap-2">
                                            <Button type="hollow" onClick={handleElimina}>
                                                ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                            <Button type="hollow" onClick={() => setNeedConfirmRow(true)}>
                                                MODIFICA DATI <SquarePen size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                            <Button type="hollow" onClick={() => setIsChangePasswordOpen(true)}>
                                                CAMBIA PASSWORD <KeyRound size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                            <Button type="hollow" onClick={() => { setIsGestioneVisible(true); setUseDataAdd(false); }}>
                                                GESTIONE CLIENTI <Factory size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                        </div>
                                        {
                                            dataRow !== null && dataRow.value["DataDeassociazione"] === null && dataRow.value["CodiceDispositivo"] !== null && (
                                                <div className="flex items-center justify-center justify-self-center mt-2">
                                                    <Button type="hollow" onClick={handleChangeDispositivo} classes="w-full">
                                                        CAMBIA DISPOSITIVO <MonitorSmartphone size={16} strokeWidth={2} className="inline-block ml-1" />
                                                    </Button>
                                                </div>
                                            )
                                        }
                                    </>
                                )
                            }
                        </>
                    )}
                </PopUp>
                <PopUp title={"Aggiungi Utente"}
                    isVisible={isAddVisible}
                    setIsVisible={setIsAddVisible}
                    needConfirm={true}
                    confirmAction={confirmPopUpAdd}
                    cancelAction={() => { setIsAddVisible(false); setDataAdd({}); }}
                >
                    <div className="flex flex-col items-center">
                        <Input
                            label="Nome *"
                            value={dataAdd["Nome"] || ""}
                            setValue={(value) => setDataAdd(prev => ({ ...prev, Nome: value }))}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Cognome *"
                            value={dataAdd["Cognome"] || ""}
                            setValue={(value) => setDataAdd(prev => ({ ...prev, Cognome: value }))}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                        <Input
                            label="Email *"
                            value={dataAdd["Email"] || ""}
                            setValue={(value) => setDataAdd(prev => ({ ...prev, Email: value }))}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                            blurAction={() => checkEmail(true)}
                        />
                        <Input
                            label="Password *"
                            value={dataAdd["Password"] || ""}
                            setValue={(value) => setDataAdd(prev => ({ ...prev, Password: value }))}
                            type="password"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                            info={true}
                            infotext='La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale ( es. [!@#$%^&*(),.?":{}|<>])'
                            infopos="l"
                        />
                        <Input
                            label="Conferma Password *"
                            value={dataAdd["ConfermaPassword"] || ""}
                            setValue={(value) => setDataAdd(prev => ({ ...prev, ConfermaPassword: value }))}
                            type="password"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                    </div>
                </PopUp>
                <PopUp title={"Gestione Clienti"}
                    isVisible={isGestioneVisible}
                    setIsVisible={setIsGestioneVisible}
                    needConfirm={true}
                    confirmAction={confirmPopUpClienti}
                    cancelAction={() => { setIsGestioneVisible(false); setUseDataAdd(null); setSelectedAziende([]); setStatusToggle1(false); if (toggleRef1.current) toggleRef1.current.setValue(false); if (toggleRef2.current) toggleRef2.current.setValue(false); }}
                >
                    <div className="flex flex-col items-center">
                        <div className="w-[80%] md:w-[70%] mt-2 flex items-center justify-between">
                            <span>Abilita su tutti i clienti</span>
                            <Toggle ref={toggleRef1} onToggleChange={handleToggleChange1} />
                        </div>
                        {
                            !statusToggle1 ? (
                                <>
                                    <div className="relative flex items-center justify-center w-full mt-4">
                                        <div className="absolute w-full h-1 bg-gray-200 dark:bg-neutral-800 rounded"></div>
                                        <span className="relative px-3 bg-gray-100 dark:bg-neutral-900 ">oppure</span>
                                    </div>
                                    <Combobox
                                        label="Clienti"
                                        options={optionsAziende.map((item) => ({ label: item["Nome"], value: item["ID"] }))}
                                        onChange={(value) => { addAzienda(value) }}
                                        classes="w-[80%] md:w-[70%] mt-1"
                                        disabled={false}
                                    />
                                    <div className="mt-3 flex flex-col gap-1 w-full">
                                        {selectedAziende.map((item, index) => (
                                            <div className="flex items-center justify-between bg-gray-200 dark:bg-neutral-800 rounded-lg px-4 py-2">
                                                <span>{item.Nome}</span>
                                                <div className="flex justify-between">
                                                    <span className="mr-2">Invio Mail: </span>
                                                    <Checkbox
                                                        checked={item.InvioEmail}
                                                        onChange={() => {
                                                            setSelectedAziende(prev => {
                                                                const updated = [...prev];
                                                                updated[index].InvioEmail = !updated[index].InvioEmail;
                                                                return updated;
                                                            });
                                                        }}
                                                        classes={""}
                                                        size={18}
                                                    />
                                                </div>
                                                <X size={20} strokeWidth={2} className="inline-block hover:cursor-pointer text-red-600 " onClick={() => {
                                                    setSelectedAziende(prev => prev.filter((_, i) => i !== index));
                                                }} />
                                            </div>
                                        ))}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="w-[80%] md:w-[70%] mt-2 flex items-center justify-between">
                                        <span>Invio delle mail: </span>
                                        <Toggle ref={toggleRef2} />
                                    </div>
                                </>
                            )
                        }
                    </div>
                </PopUp>
                <PopUp title={"Cambia password"}
                    isVisible={isChangePasswordOpen}
                    setIsVisible={setIsChangePasswordOpen}
                    needConfirm={true}
                    confirmAction={confirmPopUpPassword}
                    cancelAction={() => setIsChangePasswordOpen(false)}
                >
                    <>
                        <div className="flex flex-col items-center">
                            <div className="w-[80%] md:w-[70%] mt-2">
                                <Input
                                    label="Password *"
                                    value={dataPassword["Password"] || ""}
                                    setValue={(value) => setDataPassword(prev => ({ ...prev, Password: value }))}
                                    type="password"
                                    info={true}
                                    infotext='La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale ( es. [!@#$%^&*(),.?":{}|<>])'
                                    infopos="l"
                                />
                                <Input
                                    label="Conferma Password *"
                                    type="password"
                                    value={dataPassword["ConfermaPassword"] || ""}
                                    setValue={(value) => setDataPassword(prev => ({ ...prev, ConfermaPassword: value }))}
                                    classes="mt-2"
                                />
                            </div>
                        </div>
                    </>
                </PopUp>
            </div>
        </div>
    )
};

export default Utenti;